import Label from "@components/form/Label";
import Legend from "@components/form/Legend";
import TextArea from "@components/form/TextArea";
import TextInput from "@components/form/TextInput";
import { useAdminTransferContext } from "@context/AdminTransferContext";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import StepActions from "@components/zenith/ui/StepActions";

type WorkflowCreateAdminApprovalStep3Props = {
  onSubmit: () => void;
  onCancel: () => void;
};

const WorkflowCreateAdminApprovalStep3: FunctionComponent<
  WorkflowCreateAdminApprovalStep3Props
> = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { message, setMessage } = useAdminTransferContext();

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form className="flex flex-col grow" onSubmit={handleSubmit}>
      <fieldset className="w-full flex flex-col grow gap-2">
        <Legend>{t("notification.message")}</Legend>
        <div>
          <Label>{t("notification.enter_subject")}</Label>
          <TextInput
            type="text"
            required
            value={message?.subject}
            onChange={e => setMessage({ ...message, subject: e.target.value })}
          />
        </div>
        <div>
          <Label>{t("notification.enter_body")}</Label>
          <TextArea
            className="h-64"
            required
            value={message?.body}
            onChange={e => setMessage({ ...message, body: e.target.value })}
          />
        </div>
      </fieldset>
      <StepActions
        onPrevious={onCancel}
        onCancel={() => navigate("/zenith/workflows")}
      />
    </form>
  );
};

export default WorkflowCreateAdminApprovalStep3;
